
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ppequote",
      function () {
        return require("private-next-pages/ppequote/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ppequote"])
      });
    }
  